<template>
  <section>
    <Divider class="mt-4 mb-4 bg-delta-grey" />
    <FormRow :fieldNameArr="[$t('QBR_VN_CODE'), '']" :col1Required="true">
      <AutoComplete
        v-model="qbrVnCode"
        :placeholder="$t('QBR_VN_CODE')"
        element-id="qbrVnCode"
        @on-search="search"
        clearable
        :disabled="!canUpdate"
        slot="a"
      >
        <Option v-for="(item, index) in qbrVnCodeSourceList" :value="item" :key="index">{{ item }}</Option>
      </AutoComplete>
      <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
    </FormRow>
    <TablePage 
      :tableWidth="windowWidth"
      :columnsList="columnsList" 
      :resultList="qbrVnCodeList"
    ></TablePage>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "QBRVNCodeMaintain",
  props: {
    qbrVnCodeList: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  components: {

  },
  data() {
    return {
      qbrVnCode: "",
      qbrVnCodeSourceList: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          title: this.$t('VN_CODE'),
          key: "qbrVnCode",
          maxWidth: 150,
        },
        {
          title: this.$t('COMPANY_NAME'),
          key: "companyName",
        },
        {
          title: this.$t('CITY'),
          key: "city",
          maxWidth: 400,
        },
      ],
    }
  },
  created() {
    let vueInstance = this
    vueInstance.$vendorHttp
      .get("/group-account/" + vueInstance.group.uuid + "/data-control/QBR_VN")
      .then((response) => {
        response.data._embedded.dataControlResourceList.forEach((qbrVnCode) => {
          buildQBRVnCode(vueInstance, qbrVnCode)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters(["getUserProfile", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search() {
    },
    add() {
      const vueInstance = this
      if (!vueInstance.qbrVnCode) {
        return AlertInfo(self, "請選擇QBR VN代碼").then(() => {
          setTimeout(() => document.getElementById("qbrVnCode").focus(), 200)
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$authHttp
          .get("data-control/VN_CODE?vnCode=" + vueInstance.qbrVnCode)
          .then((response) => {
            vueInstance.toggleLoading(false)
            buildQBRVnCode(vueInstance, response.data)
            vueInstance.$linkDataControl(
              vueInstance,
              "QBR_VN",
              response.data.objectKey,
              vueInstance.group.code,
              "GROUP_USER"
            )
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
      this.qbrVnCode = ""
    },
    remove(item) {
      const vueInstance = this
      AlertDelete(vueInstance, `QBR VN代碼 ${item.qbrVnCode}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(
            vueInstance,
            "QBR_VN",
            item.qbrVnCode,
            vueInstance.group.code,
            "GROUP_USER"
          )
          vueInstance.qbrVnCodeList.splice(item._index, 1)
        })
        .catch(() => {})
    },
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBRVN_CODE_RELATION_AREA_MODIFIABLE")
      )
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
}

function buildQBRVnCode(vueInstance, qurVnCode) {
  let companyName = ""
  let city = ""
  qurVnCode.attributes.forEach((attribute) => {
    if (attribute.key == "city") {
      city = attribute.value
    }
    if (attribute.key == "companyName") {
      companyName = attribute.value
    }
  })
  vueInstance.qbrVnCodeList.push({ qbrVnCode: qurVnCode.objectKey, companyName: companyName, city: city })
}
</script>

<style scoped></style>
